var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nuxt',{attrs:{"keep-alive":"","keep-alive-props":{
      include: [
        'd2MallIndex',
        'my-integration',
        'integralStatisticsIndex',
        'taskhall'
      ]
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }